import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';
import AthenaTextarea from 'athena/components/textarea';
import { config } from '@config/pendo.config.json';

const styles = css`
  .athena-input {
    min-height: 45px !important;
  }
`;

const SubjectInput = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<typeof AthenaTextarea>>((props, ref) => {
  const translationBase = t.MENTORING_PROGRAMS.COMMUNICATIONS.COMMUNICATION_MODAL.EDIT_MODE;
  const dataQATag = config.pendo.athena.mentorshipProgram.communications.editCommunicationModal.subjectInputField;

  return (
    <div css={styles} className='subject-wrapper w-100'>
      <div className='semi-bold color-gray-2 mt-5 mb-1'>
        {translationBase.CONTENT_SECTION.SUBJECT()}
      </div>
      <AthenaTextarea
        {...props}
        withForm
        name='subject'
        required
        showLabel={false}
        placeholder={translationBase.PLACEHOLDERS.SUBJECT()}
        ref={ref}
        validationErrorTitle={t.FORM.WARNING()}
        dataQa={dataQATag}
      />
    </div>
  );
});

export default SubjectInput;
